export default __webpack_public_path__ + "static/media/I0006.104f5e9e.png";